/**
 * Role-level project visibility mode.
 *  - 'all'                 → members can see every project in the system.
 *  - 'assigned_projects'   → members see only projects they have been added to.
 *  - 'assigned_tasks'      → members see only tasks assigned to them (and only the
 *                            projects that contain at least one of those tasks);
 *                            Dashboard, Reports, Team, and Resources surfaces are hidden.
 */
export const PROJECT_VISIBILITY_VALUES = ['all', 'assigned_projects', 'assigned_tasks'];
//# sourceMappingURL=role.types.js.map